export function useUrlHelper () {
  function getQueryParams (): Record<string, string> {
    return window.document.location.search
      .slice(1)
      .split('&')
      .filter(i => i)
      .map(keyVal => keyVal.split('='))
      .reduce((params, [key, val]) => ({ ...params, [key]: val }), {} as Record<string, string>)
  }

  function isHome (): boolean {
    return window.document.location.pathname === '/'
  }

  return { getQueryParams, isHome }
}
